import type {
  AddUserConfigReply,
  AddUserConfigRequest,
  BatchAddUserConfigReply,
  BatchAddUserConfigRequest,
  CheckUserConfigReply,
  CheckUserConfigRequest,
  CreateConfigDefinitionReply,
  CreateConfigDefinitionRequest,
  DeleteConfigDefinitionReply,
  DeleteConfigDefinitionRequest,
  GetUserConfigsReply,
  GetUserConfigsRequest,
  ListConfigDefinitionsReply,
  ListConfigDefinitionsRequest,
  ListUsersByConfigKeyReply,
  ListUsersByConfigKeyRequest,
  RemoveUserConfigReply,
  RemoveUserConfigRequest,
  UpdateConfigDefinitionReply,
  UpdateConfigDefinitionRequest,
} from '@/types';
import api from './api';

export const userConfigApi = {
  // 查询用户所有配置
  getUserConfigs: async (
    data: GetUserConfigsRequest,
  ): Promise<GetUserConfigsReply> => {
    return api.post('/api/v1/user-configs/get', data);
  },

  // 检查用户是否拥有某个配置
  checkUserConfig: async (
    data: CheckUserConfigRequest,
  ): Promise<CheckUserConfigReply> => {
    return api.post('/api/v1/user-configs/check', data);
  },

  // 创建配置定义
  createConfigDefinition: async (
    data: CreateConfigDefinitionRequest,
  ): Promise<CreateConfigDefinitionReply> => {
    return api.post('/api/v1/user-configs/definitions', data);
  },

  // 更新配置定义
  updateConfigDefinition: async (
    data: UpdateConfigDefinitionRequest,
  ): Promise<UpdateConfigDefinitionReply> => {
    return api.post('/api/v1/user-configs/definitions/update', data);
  },

  // 删除配置定义（级联删除用户映射）
  deleteConfigDefinition: async (
    data: DeleteConfigDefinitionRequest,
  ): Promise<DeleteConfigDefinitionReply> => {
    return api.post('/api/v1/user-configs/definitions/delete', data);
  },

  // 分页列表配置定义
  listConfigDefinitions: async (
    data: ListConfigDefinitionsRequest,
  ): Promise<ListConfigDefinitionsReply> => {
    return api.post('/api/v1/user-configs/definitions/list', data);
  },

  // 分配配置给用户
  addUserConfig: async (
    data: AddUserConfigRequest,
  ): Promise<AddUserConfigReply> => {
    return api.post('/api/v1/user-configs/assign', data);
  },

  // 批量分配配置给用户
  batchAddUserConfig: async (
    data: BatchAddUserConfigRequest,
  ): Promise<BatchAddUserConfigReply> => {
    return api.post('/api/v1/user-configs/assign/batch', data);
  },

  // 移除用户配置
  removeUserConfig: async (
    data: RemoveUserConfigRequest,
  ): Promise<RemoveUserConfigReply> => {
    return api.post('/api/v1/user-configs/unassign', data);
  },

  // 查询某配置下的用户列表
  listUsersByConfigKey: async (
    data: ListUsersByConfigKeyRequest,
  ): Promise<ListUsersByConfigKeyReply> => {
    return api.post('/api/v1/user-configs/users/list', data);
  },
};
